import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../../Components/services/auth';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const location = useLocation();
  
  // Check if user is authenticated
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if password change is required
  if (authService.requiresPasswordChange()) {
    return <Navigate to="/force-change-password" replace />;
  }

  // Check if admin role is required
  if (requireAdmin && !authService.isAdmin()) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h2>
          <p className="text-gray-600">You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;